import _ from 'lodash';
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Clock } from '~/components';
import { Icon, FitText } from '~/utils';
import { useConfig } from '~/context';
import { IdleWrapper } from './IdleWrapper';

function BigClock( props ) {
  return (
    <Row>
      <Col className="mx-auto">
        <FitText><Clock {...props} /></FitText>
      </Col>
    </Row>
  );
}

export function DateTimeIdle( props ) {
  const config = useConfig();
  const title = config.get( 'facility.name', '' );

  return (
    <IdleWrapper>
      <Container className="idle h-100 text-center" fluid>
        <Row><Col className="mx-auto"><h1>{title}</h1></Col></Row>
        <BigClock format="dddd MMMM Do" />
        <BigClock format="h:mm a" />
        <Row>
          <Col>
          </Col>
        </Row>
        <Row className="mt-3 fixed-bottom mb-5">
          <Col className="text-center">
            <FitText>
              <span>
                <Icon icon="far:id-card" color="red" className="mx-3" />
                <Icon icon="far:id-card" color="green" className="mx-3" />
                <Icon icon="far:id-card" color="blue" className="mx-3" />
              </span>
            </FitText>
            <h1>Please swipe your pass to begin</h1>
            <h1>or press <kbd>SPACE</kbd> for more options</h1>
          </Col>
        </Row>
      </Container>
    </IdleWrapper>
  );
}
DateTimeIdle.propTypes = {
};
